import { Box, IconButton, Stack, Typography } from "@mui/material";
import ArrowUpRightIcon from "assets/svg/ArrowUpRightIcon";
import EllipseIcon from "assets/svg/EllipseIcon";
import OverviewIcon from "assets/svg/OverviewIcon";
import PlantIcon from "assets/svg/PlantIcon";
import QueryIcon from "assets/svg/QueryIcon";
import SunIcon from "assets/svg/SunIcon";
import TreeBulbIcon from "assets/svg/TreeBulbIcon";
import TreeHeartIcon from "assets/svg/TreeHeartIcon";
import PrimaryButton from "components/PrimaryButton/PrimaryButton";
import theme, { responsiveFontSize } from "themes/Theme";
import { formatNumber } from "utils/formatter";
import { commonStyle } from "../../common.styles";
import { useEffect, useState } from "react";
import { fetchDashboardTotalBalance } from "services/apiService";
import { AxiosResponse } from "axios";
import {
  DashboardTotalBalanceData,
  DashboardTotalBalanceResponse,
} from "reduxStore/dataTypes";
import { useNavigate } from "react-router-dom";
import WalletPattern from "assets/images/Pattern.webp";
import { DashboardPattern } from "assets/index";

const OverviewCard = () => {
  const navigate = useNavigate();
  const [overviewData, setOverviewData] =
    useState<DashboardTotalBalanceData | null>(null);

  const fetchDashboardBalance = async () => {
    try {
      const response: AxiosResponse<DashboardTotalBalanceResponse> =
        await fetchDashboardTotalBalance();
      if (response && response.status === 200) {
        setOverviewData(response.data.data);
      }
    } catch (error) {}
  };
  useEffect(() => {
    fetchDashboardBalance();
  }, []);

  return (
    <Box
      sx={{
        ...commonStyle.cardStyle,
        height: 320,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* ✅ Background pattern image */}
      <Box
        component="img"
        src={WalletPattern}
        alt="background pattern"
        sx={{
          position: "absolute",
          top: 1,
          right: 0,
          width: "65%",
          opacity: 0.8,

          pointerEvents: "none",
          zIndex: 0,
        }}
      />
      {/* Foreground content */}
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <Stack direction={"row"} alignItems={"center"} gap={1}>
          <OverviewIcon />
          <Typography sx={commonStyle.cardTitleText}>Overview</Typography>
        </Stack>

        <Typography sx={styles.totalBalanceText}>Total Balance</Typography>
        <Box sx={commonStyle.flexSpaceBetween}>
          <Stack direction={"row"} alignItems={"baseline"} gap={1}>
            <Typography sx={styles.totalBalance}>
              {formatNumber(Number(overviewData?.totalBalance) || 0)}
            </Typography>
            <Typography sx={styles.totalBalanceCurrency}>
              {overviewData?.cryptoTicker}
            </Typography>
          </Stack>
        </Box>

        <Stack direction={"row"} alignItems={"center"} gap={2} mt={4}>
          <PrimaryButton
            title="Transfer Money"
            rightIcon={<ArrowUpRightIcon />}
            size="medium"
            onClick={() => navigate("/dashboard/wallet")}
            viewStyle={{
              borderRadius: "999px",
              padding: "10px 24px",
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
              color: "#fff",
              fontWeight: 600,
              fontSize: responsiveFontSize(14),
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
              display: "flex",
              alignItems: "center",
              gap: 1,
              mt: { xs: 0, sm: 2 },
              transition: "all 0.2s ease-in-out",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.2)",
                background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
              },
            }}
          />

          {/* <SecondaryButton
            title={"Linked Account"}
            viewStyle={{ borderRadius: "1em" }}
            onClick={() => {}}
            size="small"
            rightIcon={<AttachmentIcon />}
          /> */}
        </Stack>
      </Box>
    </Box>
  );
};
export default OverviewCard;
const styles = {
  totalBalanceText: {
    fontSize: responsiveFontSize(14),
    color: theme.palette.primary.main,
    marginTop: "2em",
  },
  totalBalance: {
    fontSize: responsiveFontSize(45),
    color: theme.palette.text.primary,
    lineHeight: 1.5,
  },
  totalBalanceCurrency: {
    fontSize: responsiveFontSize(24),
    color: theme.palette.primary.main,
  },
  unitContainer: {
    boxShadow:
      "rgba(0, 0, 0, 0.09) 1px 1px 3px 0px inset, rgba(0, 0, 0, 0.09) -0.5px -0.5px 3px 1px inset",
    backgroundColor: theme.palette.secondary.main,
    p: 2,
    borderRadius: "0.5em",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
  },
  unitTextAccent: {
    fontSize: responsiveFontSize(12.29),
    color: theme.palette.primary.main,
  },
  unitText: {
    fontSize: responsiveFontSize(12.29),
    color: theme.palette.text.primary,
  },
};
